import React from "react";
import Modal from "../../components/Modal";
import ModalHeader from "../../components/ModalHeader";

interface Props {
  confirmModalOpen?: boolean;
  toggleConfirmModal: () => void;
  children?: any;
  title?: string;
  isShowBackBtn?: boolean;
  maxWidth?: number;
}
function ConfirmModal(props: Props) {
  const {
    confirmModalOpen,
    toggleConfirmModal,
    children,
    title,
    isShowBackBtn,
    maxWidth,
  } = props;
  return (
    <Modal
      isOpen={confirmModalOpen}
      onDismiss={toggleConfirmModal}
      minHeight={0}
      maxHeight={90}
      maxWidth={maxWidth}
    >
      <div className="flex flex-col space-y-4">
        <ModalHeader
          title={title}
          isShowBackBtn={isShowBackBtn}
          onClose={toggleConfirmModal}
          className="mb-0 zText-1"
        />
        <div className="">
          {children}
        </div>
      </div>
    </Modal>
  );
}

export default React.memo(ConfirmModal);
